import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

export enum OutputType {
  CONDITION = 'CONDITION',
  SIGNAL = 'SIGNAL',
}

export const defaultContamination = 0.1;
export const minNumEstimators = 1;
export const maxNumEstimators = 200;
export const minContamination = 0;
export const maxContamination = 0.5;

const packageName = SeeqNames.MlService.IsolationForest.Connection.UdfPackage;
const udfName = SeeqNames.MlService.IsolationForest.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;
